import { Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../Provider'
import { OPCheckBox } from '../OPcomponents/OPCheckBox'
import { OPLoadingCircle } from '../OPcomponents/OPLoadingcircle'
import OPSearch from '../OPcomponents/OPSearch'
import { Toast } from '../OPcomponents/Toast'
import '../Profile/myskills.scss'
import '../Profile/profile.scss'
import './project.scss'
import ProjectTable from './ProjectTable'

const Projects = (): JSX.Element => {
  const { t } = useTranslation()
  const rootStore = useStore()

  const { validatedUser } = rootStore.loginStore
  const { getAllProjects, loadingInitial } = rootStore.projectStore
  const { setIsSearching, setSearchValue, isSearching, hideEndedProjects, setHideEndedProjects } = rootStore.projectStore

  useEffect(() => {
    getAllProjects(validatedUser)
  }, [getAllProjects, validatedUser])

  useEffect(() => {
    return () => {
      setSearchValue('')
      setIsSearching(false)
    }
  }, [setIsSearching, setSearchValue])

  return (
    <Grid container spacing={2}>
      <Toast />
      <Grid item xs={12}>
        <p className='profile--titlebigfont'>{t('Navbar.Projects')}</p>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'
          className='gridcontainer--myskills__titlepadding none'
        >
          <Grid item>
            <OPSearch
              placeholder={t('Projects.FindProject')}
              onSearchChange={(val) => {
                setSearchValue(val)
                if (!isSearching) setIsSearching(true)
              }}
              resetValue={() => {
                if (isSearching) setIsSearching(false)
                setSearchValue('')
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      {loadingInitial ? (
        <Grid item xs={12}>
          <OPLoadingCircle />
        </Grid>
      ) : (
        <>
          <Grid item className='projects--unapprovedpadding' xs={12}>
            <OPCheckBox
              label={t('Projects.DontShowEndedProjects')}
              value={hideEndedProjects}
              leftPadding
              onChangeState={() => setHideEndedProjects(!hideEndedProjects)}
            />
          </Grid>
          <Grid item xs={12}>
            <ProjectTable />
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default observer(Projects)
